export default {
  root: {
    marginTop: 50,
    marginBottom: 50,
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  title: {
    marginBottom: '24px !important',
  },
  section: {
    color: '#637381',
  },
  button: {
    textTransform: 'none !important',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px !important',
  },
  checkboxes: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > *': {
      marginBottom: 0,
    },
  },
  notificationCenter: {
    position: 'fixed',
    right: '2rem',
    bottom: '2rem',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
};
